import { useEffect, useState } from "react";
import { redeemDatabookRetry, RetryLinkUnavailable, type EmailRetryResult } from "@/lib/databookRetryToken";

export default function DatabookRetry() {
  const [result, setResult] = useState<EmailRetryResult | null>(null);
  const [failure, setFailure] = useState<"unavailable" | "connection" | null>(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    redeemDatabookRetry().then(
      (value) => { if (active) setResult(value); },
      (error: unknown) => { if (active) setFailure(error instanceof RetryLinkUnavailable ? "unavailable" : "connection"); },
    );
    return () => { active = false; };
  }, [attempt]);
  const message = failure === "unavailable" ? "This retry link has expired or is no longer available."
    : failure === "connection" ? "Could not connect. Please try again."
    : result?.status === "already_accepted" ? "This retry has already been accepted."
    : result?.status === "scheduled" ? "Your retry is scheduled. We’ll email you when the databook is ready."
    : result ? "Your retry has been accepted. We’ll email you when the databook is ready."
    : "Starting your databook retry…";
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
      <section className="max-w-md rounded-xl border border-border p-8 text-center">
        <h1 className="mb-4 text-xl font-semibold">Databook retry</h1>
        <p role="status" className="text-sm text-muted-foreground">{message}</p>
        {failure === "connection" && <button className="mt-5 rounded-lg bg-foreground px-4 py-2 text-background" onClick={() => { setFailure(null); setAttempt((value) => value + 1); }}>Try again</button>}
      </section>
    </main>
  );
}
